import {
  FEEDBACK_FLOW_STATIC,
  FEEDBACK_TYPE_BUGS,
  FEEDBACK_TYPE_FEATURE_REQ,
  FEEDBACK_TYPE_FEEDBACK,
  IFeedbackAgentSettings,
  INVOKE_TYPE_MANUAL,
  POS_RIGHT_MIDDLE,
  RATING_ICON_TYPE_STAR,
  TYPE_NONE,
  brandingIF,
} from "../../model";
import { uploadFileBucketName } from "../../utils/config";
import {
  IConnectionDetails,
  IFeatureRequestAISettings,
  IFeatureRequestAccordionSettings,
  IFeedbackAISettings,
  IFeedbackAccordionSettings,
  ITicketAISettings,
  ITicketAccordionSettings,
} from "./types";

export const defaultBranding: brandingIF = {
  "branding-cuvo-popup-dialog-agent-bg": "#f7f8f8",
  "branding-cuvo-popup-dialog-main-title": "#011348",
  "branding-cuvo-popup-dialog-main-title-font-family": "Open Sans",
  "branding-cuvo-popup-dialog-main-title-font-weight": "700",
  "branding-cuvo-popup-dialog-main-title-font-style": "normal",
  "branding-cuvo-popup-dialog-main-title-font-size": "34px",
  "branding-cuvo-popup-dialog-main-subtitle": "#040000",
  "branding-cuvo-popup-dialog-main-subtitle-font-family": "Open Sans",
  "branding-cuvo-popup-dialog-main-subtitle-font-weight": "500",
  "branding-cuvo-popup-dialog-main-subtitle-font-style": "normal",
  "branding-cuvo-popup-dialog-main-subtitle-font-size": "16px",
  "branding-cuvo-popup-dialog-card-bg": "#ffffff",
  "branding-cuvo-popup-dialog-card-title": "#040000",
  "branding-cuvo-popup-dialog-card-title-font-family": "Open Sans",
  "branding-cuvo-popup-dialog-card-title-font-weight": "700",
  "branding-cuvo-popup-dialog-card-title-font-style": "normal",
  "branding-cuvo-popup-dialog-card-title-font-size": "20px",
  "branding-cuvo-popup-dialog-card-subtitle": "#040000",
  "branding-cuvo-popup-dialog-card-subtitle-font-family": "Open Sans",
  "branding-cuvo-popup-dialog-card-subtitle-font-weight": "500",
  "branding-cuvo-popup-dialog-card-subtitle-font-style": "normal",
  "branding-cuvo-popup-dialog-card-subtitle-font-size": "16px",
  "branding-cuvo-primary-button-bg": "#0157ff",
  "branding-cuvo-primary-button-text-color": "#ffffff",
  "branding-cuvo-primary-button-text-font-family": "Open Sans",
  "branding-cuvo-primary-button-text-font-style": "normal",
  "branding-cuvo-primary-button-text-font-weight": "400",
  "branding-cuvo-primary-button-text-font-size": "16px",
  "branding-cuvo-primary-button-border-color": "#0157ff",
  "branding-cuvo-secondary-button-bg": "#00000070",
  "branding-cuvo-secondary-button-text-color": "#ffffff",
  "branding-cuvo-secondary-button-text-font-family": "Open Sans",
  "branding-cuvo-secondary-button-text-font-style": "normal",
  "branding-cuvo-secondary-button-text-font-weight": "400",
  "branding-cuvo-secondary-button-text-font-size": "16px",
  "branding-cuvo-secondary-button-border-color": "#00000070",
  "branding-cuvo-input-label-color": "#040000",
  "branding-cuvo-input-label-font-family": "Open Sans",
  "branding-cuvo-input-label-font-style": "normal",
  "branding-cuvo-input-label-font-weight": "500",
  "branding-cuvo-input-label-font-size": "16px",
  "branding-cuvo-input-field-text-color": "#000",
  "branding-cuvo-input-field-bg-color": "#f4f5f5",
  "branding-cuvo-attachment-helper-color": "#00000060",
  "branding-cuvo-attachment-helper-font-family": "Open Sans",
  "branding-cuvo-attachment-helper-font-style": "normal",
  "branding-cuvo-attachment-helper-font-weight": "500",
  "branding-cuvo-attachment-helper-font-size": "16px",
  "branding-cuvo-card-svg-fg-color": "#0157ff",
  "branding-cuvo-card-svg-bg-color": "#0157ff1a",
  "branding-cuvo-selected-star-color": "#ffbc01",
  "branding-cuvo-unselected-star-color": "#d9d6d6",
  "branding-cuvo-card-border-color": "#00000070",
  "branding-cuvo-card-border-radius": "8px",
  "branding-cuvo-input-border-color": "#00000070",
  "branding-cuvo-input-border-radius": "8px",
  "branding-cuvo-comments-field-height": "100px",
  "branding-cuvo-editor-font-size": "16px",
  "branding-cuvo-editor-font-family": "Open Sans",
  "branding-cuvo-primary_btn-border-radius": "4px",
  "branding-cuvo-secondary_btn-border-radius": "4px",
  "branding-cuvo-selected-start-rating-uri": "",
  "branding-cuvo-unselected-start-rating-uri": "",
};

export const defaultFeedbackAgentSettings: IFeedbackAgentSettings = {
  //  platform: PLATFORM_TYPE_BROWSER,
  feedbackTypes: [
    FEEDBACK_TYPE_FEEDBACK,
    FEEDBACK_TYPE_BUGS,
    FEEDBACK_TYPE_FEATURE_REQ,
  ],
  showLogo: false,
  invokeDelay: 5,
  invokeOn: [INVOKE_TYPE_MANUAL],
  thanksStr: "Thank You",
  title: "Cuvo - Customer Voice",
  subtitle: "Voice your idea or concerns with audio-visual enhancement",
  uploadFileMaxSize: "400",
  videoAudioMaxDuration: "1.5",
  disableDefaultBtn: false,
  disableCuvo: false,
  requireEmail: true,
  captureSystemDetails: true,
  remoteBtns: [],
  widgetLookAndFeel: {
    bgColor: "#042e5b",
    fgColor: "#ffffff",
    font: "inherit",
    fontWeight: 400,
    fontStyle: "normal",
    text: "Feedback",
    icon: "",
    position: POS_RIGHT_MIDDLE,
    custom: {
      top: "",
      bottom: "",
      right: "",
      left: "",
      borderRadius: "",
      rotation: "",
      margin: "",
      padding: "",
    },
  },
  bugSettings: {
    categories: [],
    severities: ["High", "Medium", "Low"],
    categoryHeading: "Choose the area where you noticed the issue",
    severityHeading: "Severity of the issue",
    stdFeedbackHeading: "Choose all options that relate to the issue",
    generalCommentsHeading: "Describe your issue",
    attachmentHelp:
      "Choosing attachment will ask for permission to access required system resources. Please provide access for the attachments to work. The feedback dialog might close and allow you to navigate to any app page. Press capture or stop or open buttons in the dialog or toolbar to attach.",
    dialogMsg:
      "Help us understand better with audio/video/screenshot attachment",
    thanksMsg: "We will attend to your concern.",
    icon: `https://${uploadFileBucketName}.s3.amazonaws.com/bugIcon.png`,
    title: "Report an issue",
    tooltip: "Tell us your concern",
    reqComments: true,
    reqDisplayEmail: false,
    showSeverity: true,
    reqCategory: false,
  },
  feedbackSettings: {
    type: FEEDBACK_FLOW_STATIC,
    categories: [],
    ratingIcon: RATING_ICON_TYPE_STAR,
    ratingLimit: 3,
    categoryHeading: "Choose the area related to your feedback",
    ratingHeading: "How would you rate us",
    stdFeedbackHeading: "Choose all options that relate to your feedback",
    generalCommentsHeading: "Anything more you want us to know",
    attachmentHelp:
      "Choosing attachment will ask for permission to access required system resources. Please provide access for the attachments to work. The feedback dialog might close and allow you to navigate to any app page. Press capture or stop or open buttons in the dialog or toolbar to attach.",
    dialogMsg:
      "Help us understand better with audio/video/screenshot attachment",
    thanksMsg: "We appreciate your feedback",
    icon: `https://${uploadFileBucketName}.s3.amazonaws.com/feedbackIcon.png`,
    title: "Provide Feedback",
    tooltip: "Tell us your experience",
    reqComments: true,
    reqDisplayEmail: false,
    reqCategory: false,
  },
  featureReqSettings: {
    categories: [],
    categoryHeading: "Choose the area related to your request",
    stdFeedbackHeading: "Choose all options that relate to your request",
    generalCommentsHeading: "Describe your request",
    attachmentHelp:
      "Choosing attachment will ask for permission to access required system resources. Please provide access for the attachments to work. The feedback dialog might close and allow you to navigate to any app page. Press capture or stop or open buttons in the dialog or toolbar to attach.",
    dialogMsg:
      "Are there any feature or enhacements that could make your experience better?",
    thanksMsg: "We appreciate your thoughts and consideration",
    icon: `https://${uploadFileBucketName}.s3.amazonaws.com/featureIcon.png`,
    title: "Request a feature",
    tooltip: "How could we enhance your experience",
    reqComments: true,
    reqCategory: false,
  },
  bannerType: TYPE_NONE,
  bannerImage: "",
  bannerText: "",
  branding: defaultBranding,
  qrSettings: {
    addQR: true,
    qrHeading: "Scan this QR code with your phone",
    qrSubHeading:
      "To provide additional context on your query, please scan the QR code below. You will have an option to submit a screenshot, screen recording or audio recording.",
  },
};

export const defaultFeedbackAccordionSettings: IFeedbackAccordionSettings = {
  preAISettings: false,
  aiSettings: false,
  emailSettings: false,
  connectionDetails: false,
};

export const defaultTicketAccordionSettings: ITicketAccordionSettings = {
  preAISettings: false,
  aiSettings: false,
  emailSettings: false,
  connectionDetails: false,
};

export const defaultFeatureRequestAccordionSettings: IFeatureRequestAccordionSettings =
  {
    preAISettings: false,
    aiSettings: false,
    emailSettings: false,
    connectionDetails: false,
  };

export const resetFeedbackAccordionSettings: IFeedbackAccordionSettings = {
  preAISettings: false,
  aiSettings: false,
  emailSettings: false,
  connectionDetails: false,
};

export const resetTicketAccordionSettings: ITicketAccordionSettings = {
  preAISettings: false,
  aiSettings: false,
  emailSettings: false,
  connectionDetails: false,
};

export const resetFeatureRequestAccordionSettings: IFeatureRequestAccordionSettings =
  {
    preAISettings: false,
    aiSettings: false,
    emailSettings: false,
    connectionDetails: false,
  };

export const defaultFeedbackAISettings: IFeedbackAISettings = {
  llmArchitecture: "gpt3",
  KBllmArchitecture: "gpt3",
  tone: "polite",
  lengthOfResponse: 150,
  aiCreativity: 0.5,
  intelligenceLayer: [],
  kbArticles: [],
  openaiKey: "",
};

export const defaultTicketAISettings: ITicketAISettings = {
  llmArchitecture: "gpt3",
  KBllmArchitecture: "gpt3",
  tone: "polite",
  lengthOfResponse: 150,
  aiCreativity: 0.5,
  intelligenceLayer: [],
  kbArticles: [],
  openaiKey: "",
};

export const defaultFeatureRequestAISettings: IFeatureRequestAISettings = {
  llmArchitecture: "gpt3",
  KBllmArchitecture: "gpt3",
  tone: "polite",
  lengthOfResponse: 150,
  aiCreativity: 0.5,
  intelligenceLayer: [],
  kbArticles: [],
  openaiKey: "",
};

export const defaultConnectionDetails: IConnectionDetails = {
  emailProvider: "Google",
  useSecureConnection: false,
  host: "",
  port: 993,
  authenticationMode: "basic",
  username: "",
  password: "",
  clientID: "",
  tenantID: "",
  OAuthUsername: "",
  clientSecret: "",
  emailAddress: "",
  folderName: "",
};

export const defaultIsAutoAssign = {
  [FEEDBACK_TYPE_FEEDBACK]: false,
  [FEEDBACK_TYPE_BUGS]: false,
  [FEEDBACK_TYPE_FEATURE_REQ]: false,
};

export const defaultFeedbackEmailSettings = {
  sendAutoReply: false,
  autoReplyRatings: {},
  autoReplyEmailSubject: "",
  autoReplyEmailBody: "",
  emailSalutation: "",
  emailSignature: "",
};

export const defaultTicketEmailSettings = {
  sendAutoReply: false,
  autoReplySeverities: {},
  autoReplyEmailSubject: "",
  autoReplyEmailBody: "",
  emailSalutation: "",
  emailSignature: "",
};

export const defaultFeatureRequestEmailSettings = {
  sendAutoReply: false,
  autoReplyEmailSubject: "",
  autoReplyEmailBody: "",
  emailSalutation: "",
  emailSignature: "",
};
